// extracted by mini-css-extract-plugin
module.exports = {"svg":"Svg_svg__11P6s"};